import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useHomepage } from "src/context/homepage/homepage.provider";
import { useParams } from "react-router-dom";
import { Row, Col, Spinner } from "react-bootstrap";
import { getScheduleDates, shouldPublish } from "src/utils/publishUtils";
import { useErs } from "src/context/ers/ers.provider";

import Hero from "src/components/Hero/Hero";
import PgCard from "src/components/Card/PgCard";
import SectionalTabs from "src/components/SectionalTabs/SectionalTabs";
import TitleSection from "src/components/TitleSection/TitleSection";

const Promotions = () => {
  const { t, i18n } = useTranslation();
  const params = useParams();
  const { sectionCategory, sectionDescription } = useHomepage();
  const { data, fetchData } = useErs();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetchData(`promotions-${i18n.language}`)
      .then(() => {
        setLoading(false);
        setError(null);
      })
      .catch((err) => {
        setLoading(false);
        setError(err.message || t("error.somethingWentWrong"));
        console.error("Error fetching promotions data:", err);
      });
  }, [i18n.language]);

  const promotionsData = data[`promotions-${i18n.language}`];
  return (
    <PromoPage>
      <Hero
        bgColor=""
        bgImage={"home/offers-header.jpg"}
        buttonLink=""
        buttonText=""
        description={t("promotions.hero.promotionsDescription")}
        descriptionBgColor=""
        image=""
        imageAlt=""
        mainHeroText={t("promotions.hero.playgroundPromotions")}
        title=""
      >
        <SectionalTabs
          routeData={{
            route: t("routes.promotions"),
            routeCategory: "promotions",
            sectionTitle: t("promotions.hero.liveAction"),
            selectCategory: t("promotions.hero.selectPromotion"),
            selectAll: t("entertainment.selectAll"),
          }}
          isDynamic={true}
        />
      </Hero>

      <div>
        <TitleSection
          title={
            sectionCategory ? sectionCategory : t("promotions.content.header")
          }
          text={
            sectionDescription
              ? sectionDescription
              : t("promotions.content.description")
          }
        />
      </div>

      <container-wide>
        <Row
          className="g-4 gx-3"
          xs={1}
          md={2}
          lg={3}
          id="promo-card-container"
        >
          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">{t("loading")}</span>
              </Spinner>
            </div>
          ) : error ? (
            <div className="text-center text-danger">
              <p>
                {t("error.somethingWentWrong")}: {error}
              </p>
            </div>
          ) : (
            <>
              {promotionsData?.map((el) => {
                // Check if the card should render based on the publish/unpublish logic
                const shouldRender = shouldPublish(el);
                const meetsCategoryCondition =
                  sectionCategory && params.category
                    ? el.category === sectionCategory
                    : true;
                if (shouldRender && meetsCategoryCondition) {
                  // Only render button if el.url is present
                  const buttonSettings = el.url
                    ? {
                        href: el.url,
                        label: el.buttonLabel || t("button.read-more"),
                      }
                    : null;
                  return (
                    <Col key={el.key}>
                      <PgCard
                        id={el.key}
                        image={el.image}
                        imageAlt={el.imageAlt || el.title}
                        title={el.title}
                        subtitle={el.category}
                        text={el.content}
                        buttonSettings={buttonSettings}
                      />
                    </Col>
                  );
                }
                return null;
              })}
            </>
          )}
        </Row>
      </container-wide>
    </PromoPage>
  );
};

const PromoPage = styled.div`
  .hero_text_container {
    p {
      margin-bottom: 1rem;
    }
  }
  .pg-card {
    .card-header {
      flex-grow: 0;
    }
    .card-body {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      .card-text {
        flex-grow: 1;
      }
    }
  }
`;

const AnnouncementDiv = styled.div`
  &.announcement {
    width: 100%;
    max-width: 700px;
    margin: 0 auto 1.5rem;
    border-radius: 5px;
    background-color: #e7da4b;
    padding: 1rem;
    h2,
    p {
      padding: 10px;
      color: var(--black);
      text-shadow: none;
      margin: 0;
      padding: 0;
    }
    h2 {
      font-family: "Poppins", sans-serif;
      font-weight: 900;
      font-size: 20px;
      @media screen and (max-width: 991px) {
        font-size: 16px;
      }
    }
    p {
      font-size: 18px;
      margin-bottom: 0.5rem;
      @media screen and (max-width: 991px) {
        font-size: 14px;
      }
    }
  }
`;

export default Promotions;
